export const siteConfig = {
  name: "EDM Realm",
  description:
    "Discover upcoming EDM shows near you & interact with fellow ravers 💜",
  url: "https://edmrealm.com",
  links: {
    blog: "/blog",
    festivals: "/festivals",
    create: "/create",
    signup: "/signup",
    twitter: "https://twitter.com/edmrealm_",
    instagram: "https://instagram.com/edmrealm",
    facebook: "https://facebook.com/edmrealm",
  },
  footerNav: [
    {
      title: "Blog",
      href: "/blog",
    },
    {
      title: "Festivals",
      href: "/festivals",
    },
    // Add more sections with single links if needed
  ],
};

export type SiteConfig = typeof siteConfig;
